import './style.scss';

import { TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { getContent } from '@/utils/tools';
import { updateDialogueInfo } from '@/utils/sessionUtils';
import { inject, observer } from 'mobx-react';

import Msg from '@/components/Msg';
import React from 'react';
import clsx from 'classnames';
import { handleFeedbackBtnClick } from '@/utils/btnClickHandler';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';

const PREFIX = 'feedback-container';

@tracker
@inject(getChildInject('initStore'))
@observer
export default class Feedback extends React.PureComponent {
  static defaultProps = {
    // props
    options: [],
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    disabledBtn: false
  };

  constructor(props) {
    super(props);

    const {
      initStore, dialogueId, nodePointId, isHistory,
      historyDialogueId, historySessionId, kbBotId, tfNodeId, tfCaseId
    } = this.props;

    this.trackingname = TRACKING_TYPE.STANDARDIZE_BUTTON;
    this.trackingdata = {
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      kb_bot_id: kbBotId,
      tf_node_id: tfNodeId,
      tf_case_id: tfCaseId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME
    };
  }

  getButtonTracking = (button) => {
    return {
      button_id: button.button_id || '',
      button_type: button.button_type || '',
      button_text: getContent(button) || ''
    };
  }

  handleOptionClick = (option) => () => {
    const {
      dialogueId,
      dialogueType,
      listPos,
      isHistory
    } = this.props;

    handleFeedbackBtnClick(
      {
        ...option,
        isHistory
      },
      {
        dialogueId,
        dialogueType
      },
      {
        trackingname: this.trackingname,
        trackingdata: {
          ...this.trackingdata,
          ...this.getButtonTracking(option)
        }
      },
      (res) => {
        res && listPos && this.hideCurrentFeedback();
      }
    );
  }

  hideCurrentFeedback = () => {
    const { listPos } = this.props;
    updateDialogueInfo({ isDisabled: true }, listPos);
  }

  generateOption = (option, index) => {
    const { disabledBtn } = this.props;
    const props = {
      className: clsx('option-container', { disabled: disabledBtn }),
      key: `option-${index}`,
      onClick: this.handleOptionClick(option)
    };
    return <div {...props} >
      {getContent(option)}
    </div>;
  };

  render() {
    const {
      msgContent,
      isDisabled,
      options,
      passedRef
    } = this.props;

    return (
      <div
        className={PREFIX + ' horizontal'}
        ref={passedRef}
        data-trackingname={this.trackingname}
        data-trackingdata={
          JSON.stringify({
            ...this.trackingdata,
            button_details: options.map(option => ({ ...this.getButtonTracking(option) }))
          })
        }
      >
        <Msg content={msgContent} />
        {
          isDisabled
            ? null
            : <div className="options">
              {
                options.map((option, index) => {
                  return this.generateOption(option, index);
                })
              }
            </div>
        }
      </div>
    );
  }
}
